<template>
  <div class="login">

  <h1 class="title ">正在升级中...</h1>


    <!-- <h1 class="title hide">幼儿园综合活动课程方案</h1>
    <div class="card flex hide">
      <div
        :class="{ 'operating-video': true, 'operating-videoA': videoHover }"
        @mouseleave="videoLeave"
        @mouseover="videoOver"
      >
        <img
          class="operating-video-icon"
          :src="
            videoHover
              ? require('../../images/operatingVideoA.png')
              : require('../../images/operatingVideo.png')
          "
          alt=""
        />
        <div>使用指南</div>
      </div>
      <div class="card-left">
        <div style="font-size: 20px; text-align: center">
          请使用手机扫码下载APP
        </div>
        <img class="qrcode" src="../../images/appCode.png" alt="" />
      </div>
      <div class="card-right">
        <div class="login-line">
          <div
            :class="{ 'login-choose': true, 'cur-login': loginIndex == 0 }"
            @click="loginIndex = 0"
          >
            老师登录
            <img
              v-if="loginIndex == 0"
              src="../../images/login_cur.png"
              alt=""
              class="cur-login-img"
            />
          </div>
          <div
            :class="{ 'login-choose': true, 'cur-login': loginIndex == 1 }"
            @click="loginIndex = 1"
          >
            管理员登录
            <img
              v-if="loginIndex == 1"
              src="../../images/login_cur.png"
              alt=""
              class="cur-login-img"
            />
          </div>
        </div>
        <div class="login-item">
          <img
            class="login-icon"
            style="width: 28px; height: 30px; margin: 0 19px"
            :src="require('../assets/user.png')"
            alt=""
          />
          <input
            class="login-input"
            v-model="account"
            placeholder="请输入手机号码"
            type="text"
            @blur="onAccountBlur"
            @keydown.enter="toLogin"
          />
        </div>
        <div class="login-item">
          <img
            class="login-icon"
            style="width: 24px; height: 30px; margin: 0 21px"
            :src="require('../assets/password.png')"
            alt=""
          />
          <input
            class="login-input"
            v-model="password"
            placeholder="请输入密码"
            type="password"
            @keydown.enter="toLogin"
          />
        </div>
        <div class="login-tool">
          <el-checkbox
            style="color: #999; font-size: 16px"
            v-model="remember"
            @change="onRememberChange"
            >记住密码</el-checkbox
          >
          <span class="forget" @click="dialogVisible = true">忘记密码？</span>
        </div>
        <div class="login-button" type="primary" @click="toLogin">登录</div>

        <div class="register-box">
          <div class="register" @click="toRegister">没有账号？立即注册</div>
          <div class="register-line"></div>
          <div class="concat" @click="showContact = true">联系我们</div>
        </div>
      </div>
    </div> -->
        <!-- <div class="agreement">
          登录即代表同意
          <span class="agreement-btn" @click="toDownloadAgreement(1)"
            >《用户协议》</span
          >
          和
          <span class="agreement-btn" @click="toDownloadAgreement(2)"
            >《隐私政策》</span
          >
        </div> -->







    
    <!-- 忘记密码 -->
    <!-- <el-dialog
      class="forget-dialog"
      title=""
      width="432px"
      :visible.sync="dialogVisible"
    >
      <div>
        <div>学校账号忘记密码请联系平台管理员：13574869509</div>
        <div>老师账号忘记密码可通过手机验证码登录，登录后可修改密码。</div>
      </div>
    </el-dialog> -->







    <div v-if="dialogVisible" class="mask">
      <div class="forget-content">
        <div class="forget-close" @click="closeForget"></div>
        <div class="forget-title">修改密码</div>
        <div v-if="dialogVisibleStep == 1" class="forget-line">
          <div class="forget-line-title">手机号：</div>
          <el-input
            v-model="phone"
            placeholder="请输入手机号"
            style="width: 224px"
          ></el-input>
          <div v-if="!sendSms" class="get-code" @click="toSendSms">
            {{ sendFirst ? '获取验证码' : '重新获取' }}
          </div>
          <div v-if="sendSms" class="get-code">{{ smsTimes }}s</div>
        </div>
        <div v-if="dialogVisibleStep == 1" class="forget-line">
          <div class="forget-line-title">验证码：</div>
          <el-input
            v-model="code"
            placeholder="请输入验证码"
            style="width: 224px"
          ></el-input>
        </div>
        <div v-if="dialogVisibleStep == 2" class="forget-line">
          <div class="forget-line-title" style="width: 191px">新密码：</div>
          <el-input
            v-model="passwordNew"
            placeholder="请输入新密码"
            @blur="onPasswordBlur"
            style="width: 224px"
          ></el-input>
        </div>
        <div v-if="dialogVisibleStep == 2" class="forget-line">
          <div class="forget-line-title" style="width: 191px">确认密码：</div>
          <el-input
            v-model="passwordNewAgain"
            placeholder="请再次输入新密码"
            style="width: 224px"
          ></el-input>
        </div>
        <div
          @click="next"
          :class="{
            'forget-next': true,
            'forget-next-no':
              (dialogVisibleStep == 1 && (!phone || !code)) ||
              (dialogVisibleStep == 2 && (!passwordNew || !passwordNewAgain)),
          }"
        >
          <div v-if="dialogVisibleStep == 1">下一步</div>
          <div v-if="dialogVisibleStep == 2">确定</div>
        </div>
      </div>
    </div>



    <div v-if="showContact" class="mask">
      <div class="contact">
        <div class="contact-close" @click="showContact = false"></div>
        <div class="">
          您可以将您的问题发送至邮箱<span
            @click="copyContact"
            class="contact-blue"
            id="youxiang"
            >823868197@qq.com</span
          >,
        </div>
        <div>⼀般情况下，我们将在15日内回复您的请求。</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  login,
  send_sms,
  sms_auth,
  check_forget_sms,
  forget_password,
  check_phone_status,
  find_info_by_phone,
  yey_login,
} from '@/api/api.js'
export default {
  name: 'Login',
  data: () => {
    return {
      account: '',
      password: '',
      loginType: 2,
      remember: false,
      dialogVisible: false,
      dialogVisibleStep: 1,
      phone: '',
      code: '',
      sendSms: false,
      sendFirst: true,
      smsTimes: 0,
      passwordNew: '',
      passwordNewAgain: '',
      sendInterval: null,
      phoneStatus: 0, // 0未注册(审核不通过) 1注册了未审核 2审核成功
      showContact: false,
      loginIndex: 0, // 0-老师登录 1-管理员登录
      videoHover: false,
    }
  },
  mounted() {
    let remember = localStorage.getItem('yey-remember')
    if (remember) {
      this.remember = true
    }
  },
  methods: {
    copyContact() {
      let youxiang = '823868197@qq.com'
      let copyInp = document.createElement('textarea')
      // 设置高度为0  透明度为0
      copyInp.style.height = 0
      copyInp.style.opacity = 0
      copyInp.style.position = 'fixed'
      // 添加到页面上
      document.body.appendChild(copyInp)
      // 将需要复制的内容赋值给textarea
      copyInp.innerHTML = youxiang
      copyInp.select()
      document.execCommand('copy')
      this.$message({
        message: '复制成功！',
        type: 'success',
      })
    },
    toDownloadAgreement(type) {
      window.open(
        // `https://yey.mashu.cloud/#/filePreview?url=https://ms-yey.oss-cn-shanghai.aliyuncs.com/webFile/${type}.docx`
        `https://www.yeykcfa.cn/#/filePreview?url=https://ms-yey.oss-cn-shanghai.aliyuncs.com/webFile/xy${type}.pdf`
      )
    },
    onRememberChange(e) {
      console.log('change', e)
      if (e) {
        localStorage.setItem('yey-remember', true)
      } else {
        localStorage.removeItem('yey-remember')
      }
    },
    toLogin() {
      if (!this.account || !this.password) {
        this.$message({
          message: '请输入账号和密码！',
          type: 'warning',
        })
        return
      }
      yey_login({
        user_name: this.account,
        password: this.password,
        role: this.loginIndex == 0 ? 'teacher' : 'school',
      }).then((res) => {
        let data = res.data.data
        if (res.data.code == -3) {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
          return
        }
        if (res.data.code == -1) {
          if (res.data.msg == '账号被删除') {
            this.$message({
              message: '账号被删除,请重新注册！',
              type: 'error',
            })
            return
          }
          this.$message({
            message: '用户名或密码错误！',
            type: 'error',
          })
          return
        }
        if (res.data.code == -2) {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
          return
        }
        if (data.token) {
          this.hasLogin = true
          this.user = data.user
          localStorage.setItem('yey-token', data.token)
          localStorage.setItem('yey-user', JSON.stringify(data))
          localStorage.setItem('yey-password', this.password)

          // 存账号密码
          let accountInfo =
            JSON.parse(
              localStorage.getItem(`yey-account-${this.loginIndex}`)
            ) || {}
          accountInfo[this.account] = this.password
          localStorage.setItem(
            `yey-account-${this.loginIndex}`,
            JSON.stringify(accountInfo)
          )
          this.$router.push('/')
        }
      })
    },
    forget() {},

    onAccountBlur() {
      let accountInfo = JSON.parse(
        localStorage.getItem(`yey-account-${this.loginIndex}`)
      )
      if (accountInfo && accountInfo[this.account]) {
        this.password = accountInfo[this.account]
      }
    },

    toRegister() {
      this.$router.push('/register')
      // this.$router.push({ path: '/register', query: { id: 1 } })
    },

    closeForget() {
      this.dialogVisible = false
      this.dialogVisibleStep = 1
      this.phone = ''
      this.code = ''
      this.sendSms = false
      this.sendFirst = true
      clearInterval(this.sendInterval)
    },
    async toSendSms() {
      console.log('phone', this.phone)
      if (!this.phone) {
        this.$message.error('请先填写手机号')
        return
      }
      if (this.sendSms) {
        return
      }

      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.phone)) {
        this.$message.error('请填写正确手机号')
        return
      }
      let phoneStatus = 0 // 0未注册(审核不通过) 1注册了未审核 2审核成功
      let phoneRes = await check_phone_status({
        phone: this.phone,
        role: this.loginIndex == 0 ? 'teacher' : 'school',
      })
      console.log('phoneStatus', phoneStatus)
      if (phoneRes.data.data == '手机号已注册，已审核') {
        phoneStatus = 2
      }
      if (phoneRes.data.data == '手机号已注册，待审核') {
        phoneStatus = 1
        // this.$router.push({ path: '/register', query: { zcPhone: this.phone } })
      }

      if (phoneStatus == 0) {
        this.$message.error('手机号未注册')
        return
      }
      this.phoneStatus = phoneStatus

      // let findInfoRes = await find_info_by_phone({ phone: this.phone })
      // console.log('findInfoRes', findInfoRes)
      // return

      let res = await send_sms({ phone: this.phone })
      console.log('send_sms', res)
      if (res.data.code == -1) {
        if (res.data.msg == '触发分钟级流控Permits:1') {
          this.$message.error('验证码获取频繁，请于1分钟后再次尝试')
          return
        }
        if (res.data.msg == '触发小时级流控Permits:5') {
          this.$message.error('验证码获取频繁，请于1小时后再次尝试')
          return
        }
        if (res.data.msg == '触发天级流控Permits:10') {
          this.$message.error('验证码获取频繁，请于1天后再次尝试')
          return
        }
        if (res.data.msg == '用户不存在') {
          this.$message.error('当前手机号未注册，请前往注册')
        } else {
          this.$message.error(res.data.msg)
        }
        return
      }
      this.sendSms = true
      this.sendFirst = false
      this.smsTimes = 59
      clearInterval(this.sendInterval)
      this.sendInterval = setInterval(() => {
        this.smsTimes = this.smsTimes - 1
        if (this.smsTimes < 1) {
          this.sendSms = false
          clearInterval(this.sendInterval)
        }
      }, 1000)
    },
    async next() {
      if (this.dialogVisibleStep == 1) {
        // this.dialogVisibleStep = 2
        // return
        if (!this.phone) {
          this.$message.error('请先填写手机号')
          return
        }
        if (!this.code) {
          this.$message.error('请先填写验证码')
          return
        }

        let res = await check_forget_sms({
          phone: this.phone,
          v_code: this.code,
          role: this.loginIndex == 0 ? 'teacher' : 'school',
        })
        console.log('check_forget_sms', res)
        if (res.data.code == -1) {
          this.$message.error(res.data.msg)
          return
        }
        if (this.phoneStatus == 1) {
          this.$router.push({
            path: '/register',
            query: { zcPhone: this.phone },
          })
        }
        this.dialogVisibleStep = 2
      } else {
        // this.dialogVisibleStep = 1
        // this.dialogVisible = false
        // this.$message({
        //   message: '修改成功',
        //   type: 'success',
        // })
        // return
        if (!this.passwordNew || !this.passwordNewAgain) {
          this.$message.error('请先填写密码')
          return
        }
        if (this.passwordNew !== this.passwordNewAgain) {
          this.$message.error('两次密码输入不一致')
          return
        }
        let reg = /(?=.*[a-zA-z])(?=.*[0-9])(?=.*[!@#$%^&*,.;:])/g
        if (!reg.test(this.passwordNew)) {
          this.$message.error(
            '密码需包含字母、数字和特殊符号（!@#$%^&*,.;:）！'
          )
          return
        }
        let data = {
          phone: this.phone,
          password: this.passwordNew,
          confirm_password: this.passwordNewAgain,
          role: this.loginIndex == 0 ? 'teacher' : 'school',
        }
        console.log('data', data)
        forget_password(data).then((res) => {
          console.log('forget_password', res)
          this.dialogVisibleStep = 1
          this.dialogVisible = false
          this.$message({
            message: '修改成功',
            type: 'success',
          })
        })
      }
    },
    onPasswordBlur() {
      let reg = /(?=.*[a-zA-z])(?=.*[0-9])(?=.*[!@#$%^&*,.;:])/g
      if (this.passwordNew.length == 0) {
        return
      }
      if (!reg.test(this.passwordNew)) {
        this.$message.error('密码需包含字母、数字和特殊符号（!@#$%^&*,.;:）！')
      }
    },

    videoOver() {
      this.videoHover = true
    },
    videoLeave() {
      this.videoHover = false
    },
  },
}
</script>

<style lang="less" scope>
.login {
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  background: #f0f2f5;
  background-image: url(../assets/loginBg.png);
  background-position: center;
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
  .title {
    padding: 12px 0;
    font-size: 50px;
    color: #fff;
    text-shadow: 0px 6px 10px rgba(0, 121, 240, 0.3);
  }
  .flex {
    display: flex;
  }
  .card {
    width: 1166px;
    margin: 0 auto;
    .card-left {
      box-sizing: border-box;
      width: 496px;
      height: 666px;
      // padding-top: 184px;
      padding-top: 174px;
      background-color: rgb(235, 245, 255);
      border-radius: 40px 0 0 40px;
      .qrcode {
        display: inline-block;
        width: 228px;
        height: 228px;
        width: 248px;
        height: 248px;
        margin: 40px auto 0;
      }
    }
    .card-right {
      box-sizing: border-box;
      width: 670px;
      height: 666px;
      padding-top: 90px;
      border-radius: 0 40px 40px 0;
      background-color: #fff;
    }
    .login-line {
      display: flex;
      justify-content: center;
      margin-bottom: 60px;
    }
    .login-choose {
      position: relative;
      padding: 0 50px;
      font-size: 26px;
      color: #999;
      font-weight: bold;
      cursor: pointer;
      &:first-child::before {
        content: '';
        position: absolute;
        top: calc(50% - 10px);
        right: 0;
        width: 2px;
        height: 20px;
        background-color: #ccc;
        opacity: 0.7;
      }
    }
    .cur-login {
      color: #1a1a1a;
    }
    .cur-login-img {
      position: absolute;
      bottom: -26px;
      left: calc(50% - 15px);
      width: 31px;
      height: 8px;
    }
    .login-item {
      display: flex;
      align-items: center;
      width: 480px;
      height: 64px;
      margin: 30px 0 20px 96px;
      line-height: 64px;
      border-bottom: 1px solid #b8d1ea;
    }
    .login-input {
      width: 300px;
      outline: none;
      border: none;
      font-size: 20px;
      line-height: 62px;
    }
    .login-button {
      width: 462px;
      height: 64px;
      margin: 46px auto 0;
      line-height: 64px;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      color: #fff;
      background: #27b2fe;
      border-radius: 32px;
      cursor: pointer;
      user-select: none;
    }
    .login-tool {
      box-sizing: border-box;
      width: 462px;
      // margin: 0 auto;
      margin-left: 96px;
      padding-left: 22px;
      text-align: left;
      .el-checkbox__label {
        font-size: 16px;
      }
      .forget {
        margin-left: 33px;
        font-size: 16px;
        color: #999;
        user-select: none;
        cursor: pointer;
      }
    }
  }

  .agreement {
    margin: 10px 0 0 117px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666;
    line-height: 36px;
    text-align: left;
    .agreement-btn {
      color: #27b2fe;
      cursor: pointer;
    }
  }
}
.forget-dialog {
  line-height: 24px;
  .el-dialog__body {
    padding-top: 5px;
  }
  .el-dialog {
    margin-top: 40vh !important;
  }
}
@media (max-width: 1919px) and (min-width: 768px) {
  .card {
    transform-origin: 50% 0;
    transform: scale(0.8);
  }
}

.register-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  margin-top: 20px;
  .register {
    font-size: 16px;
    color: #27b2fe;
    text-decoration: underline;
    line-height: 36px;
    cursor: pointer;
  }
  .register-line {
    width: 1px;
    height: 12px;
    margin: 0 25px;
    background-color: #999;
  }
  .concat {
    position: relative;
    font-size: 16px;
    color: #808080;
    line-height: 36px;
    text-decoration: underline;
    cursor: pointer;
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(#000, 0.7);
  z-index: 9;
}
.forget-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 35px;
  height: 35px;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 10px;
    width: 13px;
    height: 2px;
    background-color: #909399;
    border-radius: 2px;
    transform: rotate(45deg);
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 10px;
    width: 13px;
    height: 2px;
    background-color: #909399;
    border-radius: 2px;
    transform: rotate(-45deg);
  }
}
.forget-content {
  position: fixed;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  width: 526px;
  height: 266px;
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  .forget-title {
    padding: 16px 0 0 30px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 36px;
    text-align: left;
  }
  .forget-line {
    display: flex;
    align-items: center;
    padding: 10px 0;
    .forget-line-title {
      width: 129px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 16px;
      text-align: right;
    }
    .get-code {
      width: 114px;
      height: 40px;
      margin-left: 10px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #00aeff;
      line-height: 40px;
      text-align: center;
      background: rgba(39, 178, 254, 0.1);
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .forget-next {
    width: 140px;
    height: 42px;
    margin: 20px auto 0;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 42px;
    text-align: center;
    background: #27b2fe;
    border-radius: 100px;
    cursor: pointer;
  }
  .forget-next-no {
    background: rgba(39, 178, 254, 0.2);
  }
}
.contact {
  position: fixed;
  top: calc(50vh - 69px);
  left: calc(50vw - 258px);
  width: 516px;
  height: 138px;
  padding: 33px 0 0 50px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #606266;
  line-height: 36px;
  text-align-last: left;
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  box-sizing: border-box;
  .contact-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(45deg);
    }
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(-45deg);
    }
  }
  .contact-blue {
    margin-left: 5px;
    color: #0da1f1;
    cursor: pointer;
  }
}

.operating-video {
  position: absolute;
  top: 0;
  right: 30px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #808080;
  line-height: 60px;
  cursor: pointer;
  .operating-video-icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
}
.operating-videoA {
  color: #0da1f1;
}

.hide {
  display: none !important;
}
</style>
